const drugsList = [
  { name: "Каннабис" },
  { name: "Гашиш" },
  { name: "Мефедрон" },
  { name: "Амфетамин" },
  { name: "МДМА" },
  { name: "Спайс" },
  { name: "Соль" },
  { name: "Героин" },
  { name: "Метадон" },
  { name: "Дезоморфин" },
];

const sexList = [{ name: "Мужской" }, { name: "Женский" }];

const regionsList = [
  { name: "Санкт-Петербург" },
  { name: "Алтайский край" },
  { name: "Амурская область" },
  { name: "Архангельская область" },
  { name: "Астраханская область" },
  { name: "Белгородская область" },
  { name: "Владимирская область" },
  { name: "Волгоградская область" },
  { name: "Вологодская область" },
  { name: "Воронежская область" },
  { name: "Забайкальский край" },
  { name: "Ивановская область" },
  { name: "Иркутская область" },
  { name: "Кабардино-Балкарская Республика" },
  { name: "Калининградская область" },
  { name: "Калужская область" },
  { name: "Камчатский край" },
  { name: "Карачаево-Черкесская Республика" },
  { name: "Краснодарский край " },
  { name: "Красноярский край" },
  { name: "Курганская область" },
  { name: "Кемеровская область - Кузбасс" },
  { name: "Кировская область" },
  { name: "Курская область " },
  { name: "Иркутская область" },
  { name: "Кабардино-Балкарская Республика" },
  { name: "Калининградская область " },
  { name: "Калужская область" },
  { name: "Камчатский край" },
  { name: "Карачаево-Черкесская Республика" },
  { name: "Липецкая область" },
  { name: "Магаданская область" },
  { name: "Московская область" },
  { name: "Мурманская область" },
  { name: "Нижегородская область" },
  { name: "Новгородская область" },
  { name: "Новосибирская область " },
  { name: "Омская область" },
  { name: "Оренбургская область" },
  { name: "Орловская область" },
  { name: "Пензенская область" },
  { name: "Пермский край" },
  { name: "Приморский край" },
  { name: "Псковская область " },
  { name: "Республика Адыгея " },
  { name: "Республика Алтай " },
  { name: "Республика Башкортостан" },
  { name: "Республика Бурятия" },
  { name: "Республика Дагестан" },
  { name: "Республика Ингушетия" },
  { name: "Пензенская область" },
  { name: "Пермский край" },
  { name: "Приморский край" },
  { name: "Псковская область " },
  { name: "Республика Адыгея " },
  { name: "Республика Алтай " },
  { name: "Республика Башкортостан" },
  { name: "Республика Бурятия" },
  { name: "Республика Дагестан" },
  { name: "Республика Ингушетия" },
  { name: "Республика Калмыкия" },
  { name: "Республика Карелия" },
  { name: "Республика Коми" },
  { name: "Республика Крым" },
  { name: "Республика Марий Эл" },
  { name: "Республика Мордовия" },
  { name: "Республика Саха (Якутия)" },
  { name: "Республика Северная Осетия-Алания" },
  { name: "Республика Татарстан" },
  { name: "Республика Тыва" },
  { name: "Республика Хакасия" },
  { name: "Ростовская область" },
  { name: "Рязанская область" },
  { name: "Самарская область" },
  { name: "Саратовская область" },
  { name: "Сахалинская область" },
  { name: "Свердловская область" },
  { name: "Смоленская область" },
  { name: "Ставропольский край" },
  { name: "Тамбовская область" },
  { name: "Тверская область" },
  { name: "Томская область" },
  { name: "Тульская область" },
  { name: "Тюменская область" },
  { name: "Удмуртская Республика" },
  { name: "Хабаровский край " },
  { name: "Ханты-Мансийский автономный округ - Югра (Тюменская область)" },
  { name: "Челябинская область" },
  { name: "Чеченская Республика" },
  { name: "Чувашская Республика - Чувашия" },
  { name: "Ямало-Ненецкий автономный округ" },
  { name: "Ярославская область" },
];

export { drugsList, sexList, regionsList };
